import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { ToastrService } from '../_services/toastr.service';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login2.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  model: any = {};
  loginForm: FormGroup;
  appName: any;
  copyright: any;
  socialProviders: string[] = [];
  isExternalLoginAllowed = false;
  baseUrl = environment.apiUrl + 'Account';

  password: any;
  email: any;

  loginErrors: any[] = [];

  isLoading: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private appComponent: AppComponent,
    private route: ActivatedRoute,
    private router: Router
  ) {
    if (this.authService.isLoggedIn()) {
      router.navigate(['home']);
    }
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const index = this.route.snapshot.queryParamMap.get('index');
    const ulhid = this.route.snapshot.queryParamMap.get('ulhid');
    if (token !== null && index !== null && ulhid !== null) {
      localStorage.setItem('token', token);
      localStorage.setItem('index', index);
      localStorage.setItem('ulhid', ulhid);
      window.location.href = localStorage.getItem('index');
    }
    const error = this.route.snapshot.queryParamMap.get('error');
    if (error !== null) {
      this.toastrService.error('Failed', error);
    }
    this.authService.IsUserLoggedIn();
    this.CreateLoginForm();
    this.appComponent.setTitle('Login');
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-two');
    this.appName = environment.projectName;
    this.copyright = environment.copyright;
    this.GetProviders();
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-two');
  }

  loginMicrosoft() {
    this.authService.loginMicrosoft();
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  GetProviders() {
    this.authService.getProviders().subscribe((result) => {
      this.socialProviders = result;
      if (this.socialProviders && this.socialProviders.length > 0) {
        this.isExternalLoginAllowed = true;
      }
    });
  }

  CreateLoginForm() {
    this.loginForm = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required]],
    });
  }

  setEmail(e) {
    if (e.target.value === '') {
      this.loginErrors = [];
    }
    this.email = e.target.value;
  }
  setPassword(e) {
    this.password = e.target.value;
  }

  login() {
    this.isLoading = true;
    this.authService
      .login({
        login: this.email,
        password: this.password,
        rememberMe: true,
      })
      .subscribe({
        next: (res) => {
          this.authService.authSuccess(res).subscribe((ress) => {
            localStorage.setItem('username', ress.body.userlist.name);
            window.location.replace('/home');
          });
        },
        error: (e) => {
          this.isLoading = false;
          const errors = e?.errors;
          this.loginErrors = [];
          this.loginErrors.push(errors?.Login[0]);
          this.loginErrors.push(errors?.Password[0]);

          console.log(this.loginErrors);
          if (e === 'Email not verified') {
            this.loginErrors.push('Email not verified');
          }
          if (
            e ===
            'The email or password you entered did not match our records. Please double-check and try again.'
          ) {
            this.loginErrors.push(
              'The email or password you entered did not match our records. Please double-check and try again.'
            );
          }
          this.isLoading = false;
          if (e === 'User is not enabled') {
            localStorage.setItem('pendingEmail', this.email);
            this.router.navigate(['/pending-user']);
          }
        },
      });
  }
}
